export default {
    "Recorridos": [
        {"image":require("./../UI/recorrido1.webp"),
        "name": "Casa Acacia",
        "title": "Recorrido Fotografía"
    },
        {"image": require("./../UI/recorrido2.webp"),
        "name": "Casa Acacia2",
        "title": "Recorrido Web"
    }
    ]
}
// module.exports = {
//     contactData: () => {
//         return[
//             {
//                 "Imagen":require("./../UI/assets/Contacto/Team/ceo-carlos-duque-umbra-3d-studio.webp"),
//                 "Nombre":"CARLOS DUQUE",
//                 "Cargo":"CEO",
//                 "Telefono":"+57 300 836 6460",
//                 "Email":"carlos@umbra3d.studio",
//                 "alt":"ceo carlos duque umbra 3d studio"
//             },
//             {
//                 "Imagen":require("./../UI/assets/Contacto/Team/cmo-diana-rodriguez-umbra-3d-studio.webp"),
//                 "Nombre":"DIANA RODRÍGUEZ",
//                 "Cargo":"CMO",
//                 "Telefono":"+57 300 346 0421",
//                 "Email":"diana@umbraint.com",
//                 "alt":"cmo diana rodriguez umbra 3d studio"
//             }]
//         }
//     }